import React, { useState } from 'react';
import ExpandMoreRoundedIcon from '@mui/icons-material/ExpandMoreRounded';
import PackageCard from './PackageCard';
import { isOpenPackage, sortPackages } from './walletFormat';
import styles from './WalletPackages.module.css';

/**
 * Pacotes em uso em cartões; concluídos e vencidos num bloco recolhido
 * "Pacotes anteriores (N)".
 */
function WalletPackages({ packages }) {
  const [showPrevious, setShowPrevious] = useState(false);
  const sorted = sortPackages(packages);
  const current = sorted.filter(isOpenPackage);
  const previous = sorted.filter((pkg) => !isOpenPackage(pkg));

  return (
    <div className={styles.wrap}>
      {current.length > 0 ? (
        <div className={styles.grid}>
          {current.map((pkg) => <PackageCard key={pkg.key} pkg={pkg} />)}
        </div>
      ) : (
        <p className={styles.none}>Nenhum pacote em uso no momento.</p>
      )}

      {previous.length > 0 && (
        <section className={styles.previous}>
          <button
            type="button"
            className={`${styles.toggle} ${showPrevious ? styles.toggleOpen : ''}`}
            onClick={() => setShowPrevious((value) => !value)}
            aria-expanded={showPrevious}
          >
            <span>Pacotes anteriores ({previous.length})</span>
            <ExpandMoreRoundedIcon className={styles.chevron} />
          </button>
          {showPrevious && (
            <div className={styles.grid}>
              {previous.map((pkg) => <PackageCard key={pkg.key} pkg={pkg} />)}
            </div>
          )}
        </section>
      )}
    </div>
  );
}

export default WalletPackages;
